import React from 'react';
import { Link as GatsbyLink, useStaticQuery } from 'gatsby';

var Link = function Link(_ref) {
  var url = _ref.url,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(GatsbyLink, {
    className: className,
    to: url,
    key: url
  }, /*#__PURE__*/React.createElement("span", {
    className: "is-uppercase has-text-weight-semibold is-full-width"
  }, label));
};

var query = "3851762029";

var Links = function Links(_ref2) {
  var _ref2$linkClassName = _ref2.linkClassName,
      linkClassName = _ref2$linkClassName === void 0 ? '' : _ref2$linkClassName;
  var data = useStaticQuery(query);
  var nodes = data.allWpMenuItem.nodes;
  return /*#__PURE__*/React.createElement(React.Fragment, null, nodes === null || nodes === void 0 ? void 0 : nodes.map(function (item, index) {
    var _item$label, _item$url;

    return /*#__PURE__*/React.createElement("div", {
      className: "column",
      key: index
    }, /*#__PURE__*/React.createElement(Link, {
      label: (_item$label = item === null || item === void 0 ? void 0 : item.label) !== null && _item$label !== void 0 ? _item$label : '',
      url: (_item$url = item === null || item === void 0 ? void 0 : item.url) !== null && _item$url !== void 0 ? _item$url : '',
      className: linkClassName
    }));
  }));
};

export default Links;